import React from 'react';
import { useSelector } from 'react-redux';
import PhoneNumbersList from './components/phone-number-list';
import Alert from '../../../../shared/design-system/components/alert';
import { RootState } from '../../../../store/root-reducer';

const PhoneNumbers: React.FC<IProps> = () => {
  const paddlePolling = useSelector(
    (state: RootState) => state.billingAndSubscription.paddlePolling,
  );

  const isPaddlePolling =
    paddlePolling?.isActive &&
    paddlePolling?.applicationType === 'dialer-phone-number';

  return (
    <div className="phone-numbers-container">
      {isPaddlePolling && (
        <Alert
          variant={Alert.Variant.Warning}
          theme={Alert.Theme.Old}
          iconIdentifier="alert-circle"
        >
          Your phone number purchase is being processed. This may take 1-2
          minutes.
        </Alert>
      )}

      <PhoneNumbersList />
    </div>
  );
};

export default PhoneNumbers;
